import React, { useContext } from "react";
import AuthContext from "../context/AuthProvider";
import Login from "./home/Login";
import BasePage from "./base/BasePage";
import Loader from "./common/Loader";

const App = () => {
	const context = useContext(AuthContext);

	if (context.isInitializing) {
		return (
			<div className="app-loading" role="status" aria-live="polite">
				<Loader size={42} />
				<span>Loading Domus IoT</span>
			</div>
		);
	}

	if (!context.auth.isLoggedIn) {
		return <Login />;
	}

	return <BasePage user={context.auth.user} />;
};

export default App;
